import React from 'react';

export const CalendarEvent = ({event}) => {

    const {title} = event;

    return (
        <div>
            <div><strong>{title}</strong></div>
        </div>
    )
}